import {
    ADD_MERCHANT_PAYMENT_CONFIG_FAILED,
    ADD_MERCHANT_PAYMENT_CONFIG_LOADING,
    ADD_MERCHANT_PAYMENT_CONFIG_SUCCESS,
    REMOVE_ADD_MERCHANT_PAYMENT_CONFIG
} from "../types";

const initialState = {
    loading: false,
    error: null,
    MerchantPayment: null,
    status: null,
};

export const addMerchantPaymentConfigurationReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
    switch (action.type) {
        case ADD_MERCHANT_PAYMENT_CONFIG_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case ADD_MERCHANT_PAYMENT_CONFIG_SUCCESS:
            return {
                ...state,
                loading: false,
                MerchantPayment: action.payload,
                status: action.status,
                error: null,
            };
        case ADD_MERCHANT_PAYMENT_CONFIG_FAILED:
            return {
                ...state,
                loading: false,
                MerchantPayment: null,
                status: action.status,
                error: action.error,
            };
        case REMOVE_ADD_MERCHANT_PAYMENT_CONFIG:
            return initialState;
        default:
            return state;
    }
};




